export interface PanelData {
  tx: number;
  ty: number;
  angle: number;
  scaleX: number;
  scaleY: number;
  duration: number;
}

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { app } from "../core/App";
/* END-USER-IMPORTS */

export default class IntroSequence extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // page
    const page = scene.add.container(0, 0);
    this.add(page);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 800);
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    page.add(cover);

    // lightning
    const lightning = scene.add.image(0, 0, "intro", "lightning.png");
    lightning.scaleX = 1.1;
    lightning.scaleY = 1.1;
    lightning.alpha = 0;
    lightning.alphaTopLeft = 0;
    lightning.alphaTopRight = 0;
    lightning.alphaBottomLeft = 0;
    lightning.alphaBottomRight = 0;
    page.add(lightning);

    // panel1
    const panel1 = scene.add.image(0, -216, "intro", "panel-1.png");
    panel1.visible = false;
    page.add(panel1);

    // panel2
    const panel2 = scene.add.image(-293, 0, "intro", "panel-2.png");
    panel2.visible = false;
    page.add(panel2);

    // panel3
    const panel3 = scene.add.image(-293, 218, "intro", "panel-3.png");
    panel3.visible = false;
    page.add(panel3);

    // panel4
    const panel4 = scene.add.image(192, 109, "intro", "panel-4.png");
    panel4.visible = false;
    page.add(panel4);

    // panel5
    const panel5 = scene.add.image(-244, -134, "intro", "panel-5.png");
    panel5.visible = false;
    page.add(panel5);

    // panel6
    const panel6 = scene.add.image(239, -181, "intro", "panel-6.png");
    panel6.visible = false;
    page.add(panel6);

    // panel7
    const panel7 = scene.add.image(-242, 190, "intro", "panel-7.png");
    panel7.visible = false;
    page.add(panel7);

    // panel8
    const panel8 = scene.add.image(239, 144, "intro", "panel-8.png");
    panel8.visible = false;
    page.add(panel8);

    // panel9
    const panel9 = scene.add.image(-369, -124, "intro", "panel-9.png");
    panel9.visible = false;
    page.add(panel9);

    // panel10
    const panel10 = scene.add.image(-74, -124, "intro", "panel-10.png");
    panel10.visible = false;
    page.add(panel10);

    // panel11
    const panel11 = scene.add.image(296, -124, "intro", "panel-11.png");
    panel11.visible = false;
    page.add(panel11);

    // panel12
    const panel12 = scene.add.image(0, 198, "intro", "panel-12.png");
    panel12.visible = false;
    page.add(panel12);

    // lists
    const page1 = [panel1, panel2, panel3, panel4];
    const page2 = [panel5, panel6, panel7, panel8];
    const page3 = [panel9, panel10, panel11, panel12];

    this.page = page;
    this.cover = cover;
    this.lightning = lightning;
    this.panel1 = panel1;
    this.panel2 = panel2;
    this.panel3 = panel3;
    this.panel4 = panel4;
    this.panel5 = panel5;
    this.panel6 = panel6;
    this.panel7 = panel7;
    this.panel8 = panel8;
    this.panel9 = panel9;
    this.panel10 = panel10;
    this.panel11 = panel11;
    this.panel12 = panel12;
    this.page1 = page1;
    this.page2 = page2;
    this.page3 = page3;

    /* START-USER-CTR-CODE */
    this.cover.alpha=0;
    /* END-USER-CTR-CODE */
  }

  private page: Phaser.GameObjects.Container;
  private cover: Phaser.GameObjects.Rectangle;
  private lightning: Phaser.GameObjects.Image;
  private panel1: Phaser.GameObjects.Image;
  private panel2: Phaser.GameObjects.Image;
  private panel3: Phaser.GameObjects.Image;
  private panel4: Phaser.GameObjects.Image;
  private panel5: Phaser.GameObjects.Image;
  private panel6: Phaser.GameObjects.Image;
  private panel7: Phaser.GameObjects.Image;
  private panel8: Phaser.GameObjects.Image;
  private panel9: Phaser.GameObjects.Image;
  private panel10: Phaser.GameObjects.Image;
  private panel11: Phaser.GameObjects.Image;
  private panel12: Phaser.GameObjects.Image;
  private page1: Phaser.GameObjects.Image[];
  private page2: Phaser.GameObjects.Image[];
  private page3: Phaser.GameObjects.Image[];

  /* START-USER-CODE */
  public static events = {
    SequenceStarted: 'sequenceStarted',
    SequenceFinished: 'SequenceFinished'
  } as const;

  public showStory() {
    let page1Data: PanelData[] = [
      {
        tx: 0,
        ty: -1000,
        angle: 0,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: -1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: -1000,
        ty: 100,
        angle: 350,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: 100,
        angle: 20,
        scaleX: 1.2,
        scaleY: 1.2,
        duration: 350
      }
    ];

    let page2Data: PanelData[] = [
      {
        tx: -1000,
        ty: -100,
        angle: 50,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: -1000,
        ty: 100,
        angle: -10,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: 100,
        angle: 60,
        scaleX: 1.2,
        scaleY: 1.2,
        duration: 350
      }
    ];

    let page3Data: PanelData[] = [
      {
        tx: -1000,
        ty: -100,
        angle: 50,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 1000,
        ty: -100,
        angle: 20,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      },
      {
        tx: 0,
        ty: 300,
        angle: 0,
        scaleX: 3,
        scaleY: 3,
        duration: 350
      }
    ];

    let startDelay = 0;
    let firstPageDelay = 0;
    let pageStartDelay = 500;
    let panelTime = 1000;
    let pageTime = panelTime * 4;
    let pageTotalTime = pageStartDelay + pageTime;
    let endDelay = 1500;

    let initialDelay = startDelay + firstPageDelay;

    this.clearAll();
    this.emit(IntroSequence.events.SequenceStarted);
   // this.raisePage(startDelay);
    this.scene.time.delayedCall(initialDelay, this.showPage, [this.page1, page1Data, pageStartDelay, panelTime], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1, this.clearPanels, [this.page1], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1, this.showPage, [this.page2, page2Data, pageStartDelay, panelTime], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 2, this.clearPanels, [this.page2], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 2, this.showPage, [this.page3, page3Data, pageStartDelay, panelTime], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 3, this.clearPanels, [this.page3], this);
    this.scene.time.delayedCall(endDelay + initialDelay + pageStartDelay * 2 + pageTotalTime * 3, () => {
      this.emit(IntroSequence.events.SequenceFinished);
    });

    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.4, this.playFX, ["SplashSmall"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 0.8, this.playFX, ["Bubbles"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 0 + pageTotalTime * 1.1, this.playFX, ["Water"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.3, this.darkenSky, [], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 1 + pageTotalTime * 1.7, this.playFX, ["Wind"], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.2, this.flash, [1], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.3, this.flash, [0], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.5, this.flash, [2], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.6, this.flash, [0], this);
    this.scene.time.delayedCall(initialDelay + pageStartDelay * 2 + pageTotalTime * 2.7, this.playFX, ["Splash"], this);
  }

  protected clearAll() {
    for (const panel of this.page1) {
      panel.setVisible(false);
    }

    for (const panel of this.page2) {
      panel.setVisible(false);
    }

    for (const panel of this.page3) {
      panel.setVisible(false);
    }
  }

  protected darkenSky(){

    this.scene.add.tween({
      targets: this.cover,
      alpha:1,
      duration: 4000,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  protected flash(num: number){
    if(num>0){
      app.audioHandler.playSound(this.scene, 'SndIntroFlash'+num, 'sfx');
    }
    this.lightning.alpha = 1;
    this.scene.add.tween({
      targets: this.lightning,
      alpha:0,
      duration: 100,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay:100
    });
  }

  protected playFX(fxname:string){
    app.audioHandler.playSound(this.scene, 'SndIntro'+fxname, 'sfx');
  }
  protected playDrown(){
    app.audioHandler.playSound(this.scene, 'SndIntroSplash', 'sfx');
  }
  protected playWind(){
    app.audioHandler.playSound(this.scene, 'SndIntroWind', 'sfx');
  }

  protected raisePage(delay: number) {
    let startingScale = this.page.scale;
    let startingY = this.page.y;

    this.page.setScale(2);
    this.page.y = 1200;

    this.scene.add.tween({
      targets: this.page,
      y: startingY,
      scaleX: startingScale,
      scaleY: startingScale,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: delay
    });
  }

  protected lowerPage() {
    this.scene.add.tween({
      targets: this.page,
      y: 1000,
      scaleX: 1.5,
      scaleY: 1.5,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In
    });
  }

  protected clearPanels(panels: Phaser.GameObjects.Image[]) {
    for (const panel of panels) {
      this.scene.add.tween({
        targets: panel,
        alpha: 0,
        duration: 1000,
        ease: Phaser.Math.Easing.Cubic.InOut
      });

      // panel.setVisible(false);
    }
  }

  protected showPage(panels: Phaser.GameObjects.Image[], panelData: PanelData[], delay: number, delayPerPanel: number) {
    for (let i = 0; i < panels.length; i++) {
      const panel = panels[i];

      let tx = panel.x;
      let ty = panel.y;
      let alpha = panel.alpha;
      let tr = panel.angle;
      let sx = panel.scaleX;
      let sy = panel.scaleY;

      panel.x += panelData[i].tx;
      panel.y += panelData[i].ty;
      panel.alpha = 0;
      panel.angle = panelData[i].angle;
      panel.scaleX = panelData[i].scaleX;
      panel.scaleY = panelData[i].scaleY;

      this.scene.add.tween({
        targets: panel,
        x: tx,
        y: ty,
        alpha: alpha,
        angle: tr,
        scaleX: sx,
        scaleY: sy,
        duration: panelData[i].duration,
        ease: Phaser.Math.Easing.Cubic.InOut,
        delay: delay,
        onStart: () => {
          panel.setVisible(true);
        }
      });

      delay += delayPerPanel;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
